import { connect } from 'react-redux';
import { selectIsFetching } from 'src/store/popup/selectors';
import PaymentBlock from '../components/PaymentBlock';
import withMobile from '../hocs/withMobile';

// Actions:
import { confirmClientAction } from '../../../store/client/actions';
import { submitCertificateAction } from '../store/certificate/sagaActions';

// Selectors:
import {
  getCardIsValid,
  getPaymentAmount,
} from '../../../store/payment/selectors';
import { getIsCertificateCreated } from '../store/certificate/selectors';

const mapStateToProps = (state) => ({
  paymentAmount: getPaymentAmount(state),
  isCardValid: getCardIsValid(state),
  isCreated: getIsCertificateCreated(state),
  isLoading: selectIsFetching(state),
});

const mapDispatchToProps = (dispatch) => ({
  onGoBack: () => dispatch(confirmClientAction(null)),
  onSubmit: () => dispatch(submitCertificateAction()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withMobile(PaymentBlock));
